<template>
  <div id="Visiting_Speakers">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>

    <usc-intro>
      <p slot="p">Even a cursory glance at the names of speakers hosted by USC reveals a rich tradition of leadership and excellence. This list is just a sample of the major figures from commerce, politics, media and other key fields — including a Nobel laureate — who have shared their hard-won wisdom with Marshall students.</p>
    </usc-intro>
   <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed>
    <usc-table :data="speakers"/>
    <usc-list-image>
      <h3 slot="title">Craig Pollard &amp; Will Ferrell</h3>
      <img slot="img" src="../../../static/Opportunities_Visiting_Speakers_4.jpg" alt="Craig Pollard and Will Ferrell">
    </usc-list-image>

    <usc-list-image>
      <h3 slot="title">Robert A. Iger</h3>
      <p slot="body">CEO, The Walt Disney Company</p>
      <img slot="img" src="../../../static/Opportunities_Visiting_Speakers_2.jpg" alt="Robert A. Iger">
    </usc-list-image>

    <usc-list-image>
      <h3 slot="title">Jessica Alba</h3>
      <p slot="body">CEO and Founder, The Honest Company</p>
      <img slot="img" src="../../../static/Opportunities_Visiting_Speakers_5.jpg" alt="Jessica Alba">
    </usc-list-image>
  </div>
</template>

<script>
import Hero from '@/components/Hero'
import Intro from '@/components/Intro'
import ListImage from '@/components/ListImage'
import Table from '@/components/Table'
import videoEmbed from '@/components/videoEmbed'

export default {
  name: 'VisitingSpeakers',
  components: {
    'usc-hero': Hero,
    'usc-intro': Intro,
    'usc-list-image': ListImage,
    'usc-table': Table,
    'usc-videoEmbed': videoEmbed
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Visiting Speakers',
        loResSrc: '../../../static/HeroImages/Advantages2.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages2.jpg'
      },
      video: {
        caption: 'Dean’s Dialogue: A Conversation with Marc Benioff of Salesforce',
        src: 'https://player.vimeo.com/video/640024726',
        frameTitle: 'Dean’s Dialogue: A Conversation with Marc Benioff of Salesforce'
      },
      speakers: [
        {'left': 'Jessica Alba', 'right': 'Actor and founder/CEO, The Honest Company'},
        {'left': 'Dan Bane', 'right': 'Chair/CEO, Trader Joe’s'},
        {'left': 'Brandon Beck', 'right': 'Cofounder/co-chair, Riot Games'},
        {'left': 'Bedi A. Singh', 'right': 'Former chief financial officer, News Corp'},
        {'left': 'Ajay Bedi', 'right': 'Chief financial officer, News Corp'},
        {'left': 'Marc Benioff', 'right': 'Chair/cofounder/co-CEO, Salesforce; USC Trustee'},
        {'left': 'Bill Clinton', 'right': 'Former U.S. President'},
        {'left': 'Christopher Cox', 'right': 'Former chair, Securities & Exchange Commission'},
        {'left': 'Robert A. Eckert', 'right': 'Board chair, Levi Strauss & Co.; former chair/CEO, Mattel'},
        {'left': 'Mark Emmert', 'right': 'President, NCAA'},
        {'left': 'Vicente Fox', 'right': 'Former president of Mexico; founder, Centro Fox'},
        {'left': 'Rachel Glaser', 'right': 'Chief financial officer, Etsy'},
        {'left': 'Robert Iger', 'right': 'CEO, The Walt Disney Company'},
        {'left': 'Jeff Immelt', 'right': 'Former chair/CEO, General Electric'},
        {'left': 'Scott Keller', 'right': 'Senior Partner, McKinsey & Company '},
        {'left': 'Arthur Laffer', 'right': 'Economist and Presidential Medal of Freedom awardee'},
        {'left': 'Todd Maclin', 'right': 'Former CEO, JP Morgan Chase Commercial Banking'},
        {'left': 'Ron Meyer', 'right': 'Former NBCUniversal vice chair; cofounder, CAA'},
        {'left': 'Jenny Ming', 'right': 'CEO, Charlotte Russe; former president, Old Navy'},
        {'left': 'Craig Pollard and Will Ferrell', 'right': 'Founder, Cancer for College; actor and comedian'},
        {'left': 'Edward C. Prescott', 'right': 'Nobel Prize winner in Economics'},
        {'left': 'Natalie Portman', 'right': 'Actor and social activist'},
        {'left': 'Ronald Sugar', 'right': 'Independent chair, Uber; former chair/CEO, Northrop Grumman'},
        {'left': 'Ted Turner', 'right': 'Founder, CNN'},
        {'left': 'Peter Ueberroth', 'right': 'Former Chair, U.S. Olympic Committee; former Major League Baseball commissioner; USC Trustee '}
      ]
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Visiting Speakers')
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/advantages/VisitingSpeakers.vue